import React from "react";
import moment from "moment";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import ActionBox from "./ActionBox";
import { statusColor, statusText } from "../../../../util";
import { RecurringEvent } from "icons";

const SingleEntry = ({ classes, events, ...rest }) => {
  const [showActionBox, setShowActionBox] = React.useState(false);
  return (
    <Box
      className={classes.singleEntryWrapper}
      onMouseEnter={() => setShowActionBox(true)}
      onMouseLeave={() => setShowActionBox(false)}
    >
      <div className={classes.recurringEventIcon}>{events[0].recurringEventType == "recurring" ? <RecurringEvent /> : null}</div>
      <Typography className={classes.singleEntryTitle} noWrap>
        {events[0].title}
      </Typography>
      <Typography className={classes.singleEntryTime} noWrap>
        {moment(events[0].startAt).format("h:mm a")} -{" "}
        {moment(events[0].endAt).format("h:mm a")}
      </Typography>
      <Box
        className={classes.singleEntryStatusBox}
        style={{ background: statusColor(events[0].status) }}
      >
        <Typography className={classes.singleEntryStatus} noWrap>
          {statusText(events[0].status)}
        </Typography>
      </Box>
      <ActionBox
        classes={classes}
        showActionBox={showActionBox}
        data={events[0]}
        {...rest}
      />
    </Box>
  );
};

export default SingleEntry;
